import React from "react"
import { Helmet } from "react-helmet"
import { useLocation } from "react-router"
import L10n from "lib/carrot-l10n"
import { Paths } from "utils/Paths"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const map = {
  "/account": l`client.account.settings`,
  "/chat": l`client.experts.chat`,
  "/read": l`Read & learn`,
  "/reimbursements/": l`Get reimbursed`,
  "/transactions": l`Financial support`,
  "/providerfinder": l`Find a provider`,
  "/support": l`client.support.carrotCardSupport`,
  "/talk-to-carrot": l`Talk to Carrot`,
  "/request-card": l`Get your Carrot Card®`,
  "/get-help": l`Get help`,
  "/insurance-details": l`Insurance details`,
  "/messages": l`Messages`,
  "/bank-details": l`Bank details`,
  "/make-a-payment": l`Make a payment`
}

function TitleMap(pathname: string): string {
  if (pathname === "/") return l`Your Carrot Plan`
  map[Paths.YOUR_BENEFIT_GUIDE] = l`Your benefit guide`
  for (const key in map) {
    if (pathname.startsWith(key)) return map[key]
  }
  return "404"
}

export function Title(props: { title?: string; productTitle?: string }): JSX.Element {
  const location = useLocation()
  const title = props.title ? props.title : TitleMap(location.pathname)
  const pageTitle = title ? `${title} | ` : ""
  const pageProductTitle = props.productTitle ? props.productTitle : "Carrot Fertility"

  return (
    <Helmet>
      <title>{`${pageTitle} ${pageProductTitle}`}</title>
    </Helmet>
  )
}
